export const ACTIONS_MACHINE_MODEL = {
  INVALIDATE: 'MACHINE_MODELS_INVALIDATE',
  RECEIVE: 'MACHINE_MODELS_RECEIVE',
  DELETE: 'MACHINE_MODEL_DELETE',
  UPDATE: 'MACHINE_MODEL_UPDATE',
};

const machineModelConstants = {};

export default machineModelConstants;
